module.exports = __webpack_public_path__ + "public/img/xiafa.77b2f40d.png";